// extracted by mini-css-extract-plugin
export default {"container":"HomeScreenPrompt_container__4Yp7h","buttonAdd":"HomeScreenPrompt_buttonAdd__4oq7D"};